import React from 'react';
import { Skeleton, Stack, SimpleGrid } from '@mantine/core';
import PageContainer from './PageContainer';

interface PageSkeletonProps {
  /** 'grid' para páginas con tarjetas en cuadrícula, 'list' para listas verticales */
  variant?: 'grid' | 'list';
  count?: number;
}

/**
 * Placeholder de carga estándar de la app (reemplaza al spinner). Imita la
 * cabecera (título + subtítulo) y el contenido, con la animación shimmer de
 * Mantine, para una transición suave y consistente entre páginas.
 */
const PageSkeleton: React.FC<PageSkeletonProps> = ({ variant = 'grid', count = 6 }) => (
  <PageContainer>
    <Stack gap="xl">
      {/* Cabecera */}
      <Stack gap={8}>
        <Skeleton height={26} width={240} radius="md" />
        <Skeleton height={12} width={320} radius="sm" />
      </Stack>

      {/* Contenido */}
      {variant === 'grid' ? (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="lg">
          {Array.from({ length: count }).map((_, i) => (
            <Skeleton key={i} height={150} radius="lg" />
          ))}
        </SimpleGrid>
      ) : (
        <Stack gap="md">
          {Array.from({ length: count }).map((_, i) => (
            <Skeleton key={i} height={72} radius="lg" />
          ))}
        </Stack>
      )}
    </Stack>
  </PageContainer>
);

export default PageSkeleton;
